import { defineComponent, createElementBlock, openBlock, createVNode, mergeProps, withCtx, createElementVNode, createBlock, unref, resolveDynamicComponent, createTextVNode, toDisplayString } from 'vue';
import BaslerLogo from './basler-components.es378.js';
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = { class: "header-logo" };
const _hoisted_2 = { class: "header-logo__main" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderLogo",
  props: {
    logoLink: {},
    tagName: {},
    logoText: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("figure", _hoisted_1, [
        createVNode(_sfc_main$1, mergeProps({ class: "header-logo__link" }, _ctx.logoLink), {
          default: withCtx(() => [
            createElementVNode("span", _hoisted_2, [
              createVNode(unref(BaslerLogo))
            ]),
            (openBlock(), createBlock(resolveDynamicComponent(_ctx.tagName || "span"), { class: "visually-hidden" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.logoText), 1)
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 16)
      ]);
    };
  }
});

export { _sfc_main as default };
